import { SearchFilter } from "./AsciiSearch"
import he from "he"

const charDec = Array.from(Array(255), (_, x) => x)
type AsciiTableProps = {
  filter?: SearchFilter
}

function stringToEntity(s: string) {
  const e = he.encode(s)
  const eNamed = he.encode(s, { useNamedReferences: true })
  return e === eNamed ? e : e + " or " + eNamed
}

const charDef = charDec.map(dec => {
  const char = String.fromCharCode(dec)
  return {
    dec: dec.toString(),
    hex: dec.toString(16),
    oct: dec.toString(8),
    bin: dec.toString(2),
    char: char,
    htmlUri: encodeURI(char),
    htmlUriComponent: encodeURIComponent(char),
    htmlEntity: stringToEntity(char),
  }
})

export function AsciiTable({ filter }: AsciiTableProps) {
  return <div>
    <table className="w-full table-fixed">
      <tbody>
        {charDef.filter(def => {
          if (filter?.oct && def.oct !== filter.oct) return false
          if (filter?.dec && def.dec !== filter.dec) return false
          if (filter?.bin && def.bin !== filter.bin) return false
          if (filter?.hex && def.hex !== filter.hex) return false
          if (filter?.char && def.char !== filter.char) return false
          if (filter?.htmlUri && def.htmlUri !== filter.htmlUri) return false
          if (filter?.htmlUriComponent && def.htmlUriComponent !== filter.htmlUriComponent) return false
          if (filter?.htmlEntity && def.htmlEntity !== filter.htmlEntity) return false
          return true
        }).map(def => {
          return <tr key={def.dec} className="even:bg-gray-100 hover:bg-blue-200">
            <td className="text-2xl">{def.char}</td>
            <td>{def.dec}</td>
            <td>{def.hex}</td>
            <td>{def.oct}</td>
            <td>{def.bin}</td>
            <td>{def.htmlUri}</td>
            <td>{def.htmlUriComponent}</td>
            <td>{def.htmlEntity}</td>
          </tr>
        })}
      </tbody>
    </table>
  </div>
}